
export class PaginationOption {
    public Total: number;
    public Take: number;
    public CurrentPage: number;
    public Url: string;
    public AjaxUrl: string;
    public Delay: boolean;
    public $DataContainer: JQuery;
    //this will be calculated automatically
    public TotalPages: number;

}
